<template>
  <div>
    <div class="topTitle clearfix">
      <div class="fl">
        <el-page-header @back="goback" content="我创建的题目">
        </el-page-header>
        <!-- <span style="cursor: pointer;" @click="goback">返回题库</span> / 我创建的题目 -->
      </div>

    </div>
    <div class="MyOj">

      <div class="clearfix top ">
        <div class="fl" style="margin-right:10px">
          <el-input v-model="keyword" prefix-icon="el-icon-search" placeholder="请输入题目名称" size="mini" clearable
            @keyup.enter.native="tchGetOwnOjProblemList"></el-input>
        </div>
        <div class="fl">
          <el-form ref="form" :model="form" :inline="true" size="mini">
            <el-form-item label="类型">
              <el-select v-model="form.resource" placeholder="" clearable>
                <el-option label="全部" value=""></el-option>
                <el-option label="比赛题" value="1"></el-option>
                <el-option label="常规题" value="0"></el-option>
              </el-select>
            </el-form-item>

          </el-form>
        </div>
        <div class="fl">
          <el-button type="primary" @click="search" icon="el-icon-search" size="mini">查询</el-button>

          <el-button type="primary" icon="el-icon-plus" @click="add" size="mini">新增问题</el-button>
        </div>
      </div>
      <el-divider></el-divider>
      <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="{
        background: '#f5f7fa',
        color: '#606266',
      }">
        <el-table-column type="index" width="50" label="序号">
        </el-table-column>
        <el-table-column prop="code" label="题目编号">
        </el-table-column>
        <el-table-column prop="sort_num" label="排序号">
        </el-table-column>
        <el-table-column prop="title" label="问题名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="" label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.contest_id === null">常规题</span>
            <span v-else>比赛题</span>

          </template>
        </el-table-column>

        <el-table-column prop="created_time" label="创建时间">
        </el-table-column>

        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="edit1(scope.row)">编辑</el-button>
            <el-button type="text" size="mini" v-if="scope.row.contest_id != null ? true : false">
              <span @click="isPublic(scope.row)" v-if="scope.row.is_public === true">转为私有</span>
              <span @click="isPublic1(scope.row)" v-if="scope.row.is_public === false">转为公共</span>

            </el-button>
            <el-button type="text" size="mini" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="clearfix" style="margin-top: 20px;">
        <div class="fr" style=" text-align: right">
          <el-pagination @current-change="handleCurrent" :current-page="page_no" :page-size="page_size"
            layout="total, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>
  
<script>
import {
  tchGetOwnOjProblemList,
  tchUpdateOjProblemVisible,
  tchUpdateOjProblemPublic

}
  from "@/api/educational.js";

export default {
  data() {
    return {
      formInline: {
        region: ''
      },
      tableData3: [],
      page_no3: 1,
      page_size3: 20,
      total3: 20,
      keyword2: '',
      form2: {
        resource: '',
      },
      page_no2: 1,
      page_size2: 20,
      total2: 20,
      addForm: {
        sort_num: 0

      },
      tableData2: [
        {
          title: '题目',
          name: 'root',
          time: '2000-5-16 06:12:45',
        }
      ],
      form1: {
        resource: '',
      },
      dialogVisible: false,
      page_no1: 1,
      page_size1: 20,
      total1: 20,
      keyword1: '',
      tableData1: [
        {
          id: 10,
          Display_id: '1001',
          title: '题目',
          name: 'root',
          time: '2000-5-16 06:12:45',
          isActive: true,
        }
      ],
      page_no: 1,
      page_size: 20,
      total: 20,
      tableData: [],
      keyword: '',
      activeName: 'first',
      form: {
        resource: ''
      }
    }
  },
  mounted() {
    this.tchGetOwnOjProblemList()
  },
  methods: {
    search() {
      this.page_no = 1
      this.tchGetOwnOjProblemList()
    },
    isPublic1(val) {

      tchUpdateOjProblemPublic({
        id: val.id,
        is_public: '1'
      }).then((res) => {
        console.log(res)
        this.$message.success('更新成功！')
        this.tchGetOwnOjProblemList()
      })

    },
    isPublic(val) {

      tchUpdateOjProblemPublic({
        id: val.id,
        is_public: '0'
      }).then((res) => {
        console.log(res)
        this.$message.success('更新成功！')
        this.tchGetOwnOjProblemList()
      })

    },
    goback() {
      this.$router.go(-1)
    },
    del(row) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        tchUpdateOjProblemVisible({
          id: row.id,
          visible: 0
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.tchGetOwnOjProblemList()



        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    //获取我的题目列表
    tchGetOwnOjProblemList() {
      tchGetOwnOjProblemList({
        title_code: this.keyword,
        isContest: this.form.resource,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log(res, 111)
        this.tableData = res.ojProblemList
        this.total = res.total
      })
    },
    edit1(row) {
      if (row.contest_id) {
        this.$router.push({
          name: "addQuestion",
          query: {
            problem: row.id,
            edit: '1',
            edt: 'edt',
            type: 'Game',
            contest_id: row.contest_id
          }

        });
      } else {
        this.$router.push({
          name: "addQuestion",
          query: {
            problem: row.id,
            edit: '1',
            edt: 'edt'
          }

        });

      }
      // sessionStorage.setItem('isMarkDown1', row.description_show_type)


    },

    addMyGame() {
      this.$router.push({
        name: 'addMyGame'
      })
    },



    add() {
      sessionStorage.setItem('isMarkDown1', '1')

      this.$router.push({
        name: 'addQuestion',
        query: {
          typecontent: 'add',
          totalNum: this.total

        }
      })
    },
    handleCurrent(val) {
      this.page_no = val
      this.tchGetOwnOjProblemList()

    },

  }

}
</script>
  
<style scoped lang="scss">
.MyOj {
  margin: 10px;
  padding: 20px;
  min-height: 100vh;
  background: #fff;
  box-sizing: border-box;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}

.top {
  font-size: 18px;
  font-weight: 300;
}

::v-deep .el-divider--horizontal {
  margin-top: 0px;
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;


  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.MyOjMian {
  margin-top: 20px;
  background: #fff;
}
</style>